import { useView } from './ArcViewContext';

function useCurrentView(defaultView) {
  const { current: view } = useView();
  if (!view) {
    if (defaultView)
      return defaultView;
    throw new Error(`useCurrentView must be used in a MapContext`);
  }
  return view;
}
function useCurrentMapView() {
  const view = useCurrentView();
  if (view.type === "3d")
    throw new Error(`useCurrentMapView must be used within a 2D MapContext`);
  return view;
}
function useCurrentSceneView() {
  const view = useCurrentView();
  if (view.type === "2d")
    throw new Error(`useCurrentSceneView must be used within a 3D MapContext`);
  return view;
}

export { useCurrentMapView, useCurrentSceneView, useCurrentView };
